import React from 'react'
import block from 'bem-cn'

import { ReactComponent as ActivosBlackSVG } from 'shared/img/activos-black.svg'
import { ReactComponent as WhatsappSVG } from 'shared/img/whatsapp.svg'

import { useGetAgentLinks } from 'shared/hooks/useGetAgentLinks'

import './AgentSocialLinks.scss'

const b = block('agent-social-links')

export const AgentSocialLinks = () => {
  const { whatsapp, activosBlackLink } = useGetAgentLinks()

  const link = activosBlackLink ?? whatsapp?.link

  if (!link) return null

  return (
    <div className={b()}>
      <a className={b('link')} href={link} target="_blank" rel="noreferrer">
        {activosBlackLink ? <ActivosBlackSVG /> : <WhatsappSVG />}
      </a>
    </div>
  )
}
